/*
 * Public API Surface of ngx-typed-js
 */

export * from './lib/ngx-typed-js.component';
export * from './lib/ngx-typed-js.module';
